<template>
  <div>
  <div class="btn-group" role="group" aria-label="Action buttons">
    <button v-if="canVerify" type="button" class="btn btn-success" @click="verifyRequest">{{ $t("Verify") }}</button>
    <button v-if="canCancel" type="button" class="btn btn-danger" @click="cancelModal = true">{{ $t("Cancel request") }}</button>
    <button v-if="canCancelPurchase" type="button" class="btn btn-dark" @click="cancelPurchaseModal = true">{{ $t("Cancel purchase") }}</button>
    <button v-if="canAssign" type="button" class="btn btn-primary" @click="tryPurchase">
      {{ userRole !== "system" ? $t("Purchase for ") + requestData.cost.companyCommission/100+'€' : $t("Assign") }}
    </button>
    <button v-if="canNoShow" type="button" class="btn btn-danger" @click="noShowModal = true">{{ $t("Mark as no-show") }}</button>
<!--    <button v-if="canDownloadPaymentNote" type="button" class="btn btn-primary" @click="downloadPaymentNote(requestData.id, requestData.refNumber, requestData.clientId)"> <i class="fa fa-download"></i> {{ $t("Payment note") }}</button>-->
    <button v-if="canReviewRequest" type="button" class="btn btn-info" @click="showReviewRequest = true">
      <i class="fa fa-ranking-star"></i> {{ $t("Add Review") }}
    </button>
    <button v-if="hasReview" type="button" class="btn btn-info" @click="getAndShowReview()">
      <i class="fa fa-ranking-star"></i> {{ $t("Check Review") }}
    </button>
    <button v-if="canDownloadReceipt" type="button" class="btn btn-info btn-sm" @click="downloadReceipt(requestData.id)">
      <i class="fa fa-download"></i> {{ $t("Receipt for client") }}
    </button>
    <button v-if="hasReview" type="button" class="btn btn-info" @click="getAndShowReview()">
      <i class="fa fa-ranking-star"></i> {{ $t("Check Review") }}
    </button>
</div>

    <modal id="noShowModal" :show="noShowModal" @close="noShowModal = false">
      <template #header>
        <h5 class="modal-title">
          {{ "Mark as no-show" }}
        </h5>
      </template>
      <div>
        <div class="pl-lg-6">
          <div class="row">
            <div v-if="requestData !== null && ['verified', 'purchased'].includes(requestData.status) && requestData.mDeadline < today" class="col-lg-12 text-start p-3">
              <b class="text-danger">
                {{ $t("By doing this") }} {{ requestData.employeeName }} {{ $t("will receive a penalty of") }}
                {{ requestData.hasOwnProperty("cost") ? (requestData.cost.totalCost/100)*( $store.state.settings.employeePenaltyPercent)/100 : 0 }}€
              </b>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <submit-button
            :alert-message="errorMessage"
            :state="loadingProcess"
            @clicked="markNoShow()"
        >
          {{ $t("Submit") }}
        </submit-button>
      </template>
    </modal>

    <modal id="cancellationModal" :show="cancelModal" @close="cancelModal = false">
      <template #header>
        <h5 class="modal-title">
          {{ $t("Request Cancellation") }}
        </h5>
      </template>
      <div>
        <div class="pl-lg-6">
          <div class="row">
            <div class="col-lg-12">
              <base-input
                  :label="$t('Cancellation reason')"
                  alternative=""
                  :error="v$.reason.$errors.map( err => { return err.$message })[0]"
                 >
                <textarea
                    v-model="reason"
                    rows="4"
                    class="form-control form-control-alternative"
                    :placeholder="$t('The reason of cancellation')"
>
                </textarea>
              </base-input>
</div>
            <div v-if="userRole === 'system' && requestData.buyerId" class="col-lg-12 text-start">
              <div class="form-group has-label" :class="{'has-danger': v$.cancelActions.$error }">
              <label class="form-control-label">{{ $t("Select action") }}</label>
              <multiselect
                  v-model="cancelActions"
                  :options="[
                      {key:'canceled', value: 'Just cancel the request'},
                      {key:'canceled_refund', value: 'Cancel the request and manually refund the Partner'},
                      {key:'canceled_abandoned', value: 'Cancel the request partner cannot make it, no refund'}
                  ]"
                  placeholder="Select"
                  :show-labels="false"
                  label="value"
                  required
                  track-by="key"
                  class=""
              ></multiselect>
              <div v-if="v$.cancelActions.$invalid" class="text-danger invalid-feedback" style="display: block;">
                {{ v$.cancelActions.$errors.map( err => { return err.$message })[0] }}
              </div>
              </div>
            </div>
<!--            <div v-if="requester != null && requestData !== null && ['VERIFIED', 'CLAIMED'].includes(requestData.status) && requestData.mDeadline < today" class="col-lg-12 text-start p-3">-->

<!--              <b v-if="requester.key === 'employee' " class="text-danger">-->
<!--                By doing this {{requestData.employeeName }} will receive a penalty of-->
<!--                {{ requestData.hasOwnProperty("cost") ? (requestData.cost.totalCost/100)*( $store.state.settings.employeePenaltyPercent)/100 : 0 }}€-->

<!--              </b>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <template #footer>
        <submit-button
            :alert-message="errorMessage"
            :state="loadingProcess"
            @clicked="cancelRequest()"
        >
          {{ $t("Submit") }}
        </submit-button>
      </template>
    </modal>
    <review-modal :has-review="hasReview" :loading-process="loadingProcess" :error-message="errorMessage" :show-review-request="showReviewRequest" :review-model="reviewModel" @close-modal="showReviewRequest = false" @submit-review="submitReview"></review-modal>
    <modal id="purchaseCancellationModal" :show="cancelPurchaseModal" @close="cancelPurchaseModal = false">
      <template #header>
        <h5 class="modal-title">
          {{ $t("Request Purchase Cancellation") }}
        </h5>
      </template>
      <div>
        <div class="pl-lg-6">
          <div class="row">
            <div class="col-lg-12">
              <base-input
                  :label="$t('Cancellation reason')"
                  alternative=""
                  :error="v$.reason.$errors.map( err => { return err.$message })[0]"
              >
                <textarea
                    v-model="reason"
                    rows="4"
                    class="form-control form-control-alternative"
                    :placeholder="$t('The reason of cancellation')"
>
                </textarea>
              </base-input>
            </div>
            <div v-if="requestData.hasOwnProperty('mDeadline')" class="col-lg-12 text-start p-3">
              <b v-if="requestData.mDeadline.toDate() <= today && userRole !== 'employee'" class="text-danger">
                {{ $t("By doing this") }} {{ requestData.employeeName }} {{ $t("will receive a penalty of") }}
                {{ requestData.hasOwnProperty("cost") ? (requestData.cost.companyCommission)/100 : "" }}€
              </b>
              <b v-else-if="userRole === 'employee'" class="text-danger">
                {{ $t("You are about to cancel your purchase.") }} <br>
                {{ $t("You are not entitled to a refund.") }}
              </b>
              <b v-else-if="userRole !== 'employee'" class="text-success">
                {{ $t("The request will be switch to Verified in order to be available for other Partners") }}
              </b>
              <br v-if="userRole === 'system'">
              <b v-if="userRole === 'system'" class="text-success">
                {{ $t("Partner is expecting a refund.") }}
              </b>
            </div>
</div>
        </div>
      </div>
      <template #footer>
        <submit-button
            :alert-message="errorMessage"
            :state="loadingProcess"
            @clicked="cancelPurchasedRequest()"
        >
          {{ $t("Submit") }}
        </submit-button>
      </template>
    </modal>
    <modal id="assignModal" :show="assignModalBool" :dismissable="false" @close="closeCheckout(false)">
      <template #header>
        <h5 class="modal-title">
          {{ userRole === 'system' ? $t("Assign Request") : $t("Purchase Request") }}
        </h5>
      </template>
      <div>
        <div v-if="!showCheckoutPage" class="pl-lg-6">
          <div class="row">
            <div v-if="userRole === 'system'" class="col-lg-12">
              <div class="form-group has-label" :class="{'has-danger': v$.assignEmployeeId.$error }">
              <label class="form-label">{{ $t("Select employee to assign request") }}</label>
              <multiselect
                  v-model="assignEmployeeId"
                  :show-labels="false"
                  label="name"
                  track-by="id"
                  :placeholder="$t('Select employee')"
                  :options="employees"
              >
              </multiselect>
              <div v-if="v$.assignEmployeeId.$invalid" class="text-danger invalid-feedback" style="display: block;">
                {{ v$.assignEmployeeId.$errors.map( err => { return err.$message })[0] }}
              </div>
                </div>
            </div>
            <div v-else class="col-lg-12 text-start table-responsive">
              <span> {{ $t("You are about to purchase the following request") }}</span>
              <table class="table">
                <tr>
                  <th>{{ $t("Type") }}</th>
                  <td>{{ $t(requestData.serviceType ?? "") }}</td>
                </tr>
                <tr v-if="requestData.serviceType === 'shift'">
                  <th>{{ $t("Shift date") }}</th>
                  <td>{{ requestData.hasOwnProperty('mStartDate') ? requestData.mStartDate.format("dddd, DD MMM YYYY") : '' }}</td>
                </tr>
                <tr v-else>
                  <th>{{ $t("Service date") }}</th>
                  <td>{{ requestData.hasOwnProperty('mStartDate') ? requestData.mStartDate.format("dddd, DD MMM YYYY") : '' }}</td>
                </tr>
                <tr v-if="requestData.serviceType === 'shift'">
                  <th>{{ $t("Shift time") }}</th>
                  <td>{{ requestData.hasOwnProperty('mStartDate') ? requestData.mStartDate.format("HH:mm") : '' }} - {{ requestData.hasOwnProperty('mEndDate') ? requestData.mEndDate.format("HH:mm") : '' }}</td>
                </tr>
                <tr>
                  <th>{{ $t("Request price") }}</th>
                  <td>{{ getValueOrDefault(requestData.cost ?? {}, 'totalCost', '' )/100+'€' ?? '' }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <checkout-page v-else @close-modal="closeCheckout" @got-payment-intent="savePaymentIntent"></checkout-page>
      </div>
      <template #footer>
        <div v-if="!showCheckoutPage" class="col-lg-12 text-end pb-3" :class="[{ 'has-danger': termsAndConditionsDirty }]">
          <input v-model="termsAndConditions" class="form-check-input p-2 float-end" type="checkbox" value="false">
          {{ $t("I agree to the") }}
          <a class="text-decoration-underline pe-2" target="_blank" :href="`/terms-and-conditions${$store.state.locale === 'el' ? '-gr' : ''}.html`">
            {{ $t("terms & conditions") }}
          </a>
          <div v-if="termsAndConditionsDirty" class="text-danger invalid-feedback"
               style="display: block;"
          >
            {{ $t("Please accept terms & conditions") }}
          </div>
        </div>
        <submit-button
            v-if="!showCheckoutPage"
            :alert-message="errorMessage"
            :state="loadingProcess"
            @clicked="assignRequest()"
        >
          {{ $t("Pay") }} {{ getValueOrDefault(requestData.cost ?? {}, 'companyCommission', '' )/100+'€' }}
        </submit-button>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal"
import useVuelidate from "@vuelidate/core"
import {helpers, required} from "@vuelidate/validators"
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import {auth, stripeSk} from "@/main"
import BaseInput from "@/components/BaseInput.vue"
import SubmitButton from "@/components/SubmitButton.vue"
import ReviewModal from "@/views/Modals/ReviewModal.vue"

import { loadStripe } from "@stripe/stripe-js"
import CheckoutPage from "@/views/Requests/Checkout.vue"
import {getAnalytics, logEvent} from "firebase/analytics"
import axios from "axios"
// import BaseToggle from "@/components/BaseToggle.vue"

const arrayQuestionsValidator = (value) => {
  for (let i = 0; i < value.length; i++) {
    if (!value[i].hasOwnProperty("value")) {
      return false
    }
  }

  console.log("arrayQuestionsValidator", value)
  return Array.isArray(value)
}
export default {
  name: "ActionButtons",
  components: {CheckoutPage, ReviewModal, SubmitButton, BaseInput, Modal},
  props: {
    requestData: {
      type: Object,
      description: "requestData",
    },
  },
  emits: ["fetch", "getRequest"],
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      paymentIntent: null,
      termsAndConditions: false,
      termsAndConditionsDirty: false,
      isRefundable: false,
      reviewModel: {
        score: null,
        questions: [
          {
            question: "Q1",
            order: 1,
            percentageScore: 15,
          },
          {
            question: "Q2",
            order: 2,
            percentageScore: 15
          },
          {
            question: "Q3",
            order: 3,
            percentageScore: 15
          },
          {
            question: "Q4",
            order: 4,
            percentageScore: 15
          },
          {
            question: "Q5",
            order: 5,
            percentageScore: 40
          }
        ],
        comment: ""
      },
      showCheckoutPage: false,
      showReviewRequest: false,
      today: new Date(),
      employees: [],
      cancelActions: {key:"canceled", value: "Just cancel the request"},
      assignModalBool: false,
      assignEmployeeId: "",
      model: {},
      errorMessage: "",
      loadingProcess: "",
      cancelModal: false,
      requester: null,
      cancelPurchaseModal: false,
      noShowModal: false,
      reason: null,
      rating: 0
    }
  },
  validations () {
    return {
      // requester: {
      //   required
      // },
      cancelActions: {
        required
      },
      reason: {
        required
      },
      assignEmployeeId: {
        required
      }
    }
  },
  computed: {
    userRole(){
      return this.$store.state.user?.claims?.role ?? null
    },
    canDownloadReceipt(){
      if (this.requestData.buyerId !== this.$store.state.user.claims.user_id && this.userRole !== "system"){
        return false
      }
      return true
    },
    hasReview(){
      if (this.userRole && !["client", "system"].includes(this.userRole)){
        return false
      }

      return this.requestData.hasOwnProperty("clientReviewId") && this.requestData.clientReviewId != null
    },
    canReviewRequest(){
      return false
      if (this.userRole && this.userRole !== "client"){
        return false
      }
      if (this.requestData.hasOwnProperty("mEndDate") && this.requestData.mEndDate.toDate() > this.today ){
        return false
      }
      if (this.requestData.hasOwnProperty("clientReviewId") && this.requestData.clientReviewId != null){
        return false
      }

      return true
    },
    canVerify(){
      return false

      if (this.userRole && this.userRole !== "system"){
        return false
      }
      if (this.requestData.hasOwnProperty("mStartDate") && this.requestData.mStartDate.toDate() < this.today ){
        return false
      }
      return this.requestData.status === "pending"
    },
    canCancel(){

      if (this.userRole && this.userRole === "employee"){
        return false
      }
      if (this.requestData.hasOwnProperty("mStartDate") && this.requestData.mStartDate.toDate() < this.today ){
        return !!(this.userRole && this.userRole === "system" && this.requestData.status === "verified")
      }
      return ["pending_payment", "verified", "purchased"].includes(this.requestData.status)
    },
    canCancelPurchase(){
      if (this.requestData.hasOwnProperty("mStartDate")  && this.requestData.mStartDate.toDate() < this.today){
        return false
      }

      if (this.requestData.buyerId !== this.$store.state.user.claims.user_id && this.userRole !== "system"){
        return false
      }
      return ["purchased"].includes(this.requestData.status)
    },
    canAssign(){
      if (["client", "system"].includes(this.userRole)){
        return false
      }
      if (this.requestData.hasOwnProperty("mStartDate")  && this.requestData.mStartDate.toDate() < this.today ){
        return false
      }
      return this.requestData.status === "verified"
    },
    // canDownloadPaymentNote(){
    //   if (!["finished", "purchased"].includes(this.requestData.status)){
    //     return false
    //   }
    //
    //   if (this.userRole === "system"){
    //     return true
    //   }
    //
    //   if (this.userRole === "client" && this.requestData.clientId === this.$store.state.user.claims.clientId){
    //     return true
    //   }
    //
    //   return this.userRole === "employee" && this.requestData.buyerId === this.$store.state.user.claims.user_id
    // },
    canNoShow(){
      if (this.requestData.status !== "purchased" || !["system", "client"].includes(this.userRole)){
        return false
      }

      return this.requestData.hasOwnProperty("mStartDate")  ? this.requestData.mStartDate.toDate() <= this.today : false
    }
  },
  watch: {
    requestData(newVal) {
      console.log("newVal", newVal)
      this.model = newVal
    },
  },
  methods: {
    savePaymentIntent(paymentIntent){
      this.paymentIntent = paymentIntent
    },
    async downloadReceipt(requestId) {
      const axios = require("axios")
      const user = auth.currentUser
      if (user == null) {
        alert("sorry cont do this right now")
        return
      }

      const analytics = getAnalytics()
      logEvent(analytics, "click", {
        item_id: "download",
        page_title: this.$route.name
      })

      const token = await user.getIdToken()
      const functionUrl = FirebaseFunctionsHelper.getFunctionsUrl("request-receipt")
      const config = {
        method: "get",
        url: functionUrl+"?requestId="+requestId+"&language="+this.$store.state.locale,
        responseType: "blob",
        headers: {
          "Authorization": "Bearer " + token
        }
      }
      this.$swal.showLoading()
      const self = this
      axios(config)
          .then(function (response) {
            console.log(response)
            const href = URL.createObjectURL(response.data)

            // create "a" HTML element with href to file & click
            const link = document.createElement("a")
            link.href = href
            link.setAttribute("download", "RECEIPT-"+self.requestData.refNumber+".pdf") //or any other extension
            document.body.appendChild(link)
            link.click()
            self.$swal.close()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          })
          .catch(function (error) {
            self.$swal.close()
            console.log(error)
          })
    },
    async closeCheckout(refresh) {
      console.log("closeCheckout", refresh)
      this.showCheckoutPage = false
      this.assignModalBool = false
      if (refresh) {
        await this.$swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3500,
          timerProgressBar: true,
          icon: "success",
          title: this.$t("Request purchased!")
        }).then( () => {
          if (this.requestData.status === "verified"){
            console.log("yes i did")
            this.$emit("getRequest")
          }
        })
      } else {
        if (this.paymentIntent) {
          console.log("with paymentIntent", this.paymentIntent.id)
          await FirebaseFunctionsHelper.callFunction("request-cancelPayment",
              {
                paymentIntentId: this.paymentIntent.id,
                requestId: this.requestData.id
              }
          )
          this.paymentIntent = null
        }
      }
    },
    async stripeCheckout(data) {
      this.$swal.showLoading()

      try {
        // const paymentIntent = await FirebaseFunctionsHelper.callFunction("request-buy", data)

        // const stripe = await loadStripe(paymentIntent.publishableKey)

        this.showCheckoutPage = true

        const params = {
          success_url: window.location.origin,
          cancel_url: window.location.origin,
          mode: "payment",
          custom_text: {
            submit: {
              message: "The invoice will be marked as paid as soon as we confirm the payment."
            }
          },
          allow_promotion_codes: true,
          payment_intent_data: "paymentIntent"
            // metadata: {
            //   userId: this.$store.state.user.claims.user_id,
            //   phoneNumber: this.$store.state.user.claims.phone_number,
            //   invoiceId: this.invoiceData.id,
            //   invoiceRef: this.invoiceData.invoiceRef
            // },

        }

        // let checkoutSession = await stripe.checkout.sessions.create(params)
        // window.location.href = checkoutSession.url
        // console.log("result", result)

      } catch (e) {
        this.$swal.hideLoading()
        this.$swal.fire({
          icon: "error",
          html: e.message + " <br> <b>Please contact support.</b>",
          title: "Something went wrong!",
        })
      }
    },
    async getAndShowReview(){
      await this.$store.dispatch("fetchClientRequestReview", {employeeId: this.requestData.buyerId, reviewId: this.requestData.clientReviewId}).then((data) => {
        // console.log("fetchClientRequestReview", data)
        // this.employees = data.data
        this.reviewModel.comment = data.comment
        this.reviewModel.score = parseFloat(data.score).toFixed(2)
        this.reviewModel.questions = data.results.map(item => {
          return {
            ...item,        // Spread the existing properties of the object
            value: item.rating // Add the new property `score` with the value from `value`
          }
        })
      })
      this.showReviewRequest = true
    },
    async submitReview(){

      let invalid = false
      for (let i = 0; i < this.reviewModel.questions.length; i++){
        const question = this.reviewModel.questions[i]
        if (!question.hasOwnProperty("value") || question.value === "" || question.value === null){
          this.reviewModel.questions[i].isInvalid = true
          invalid = true
        }
      }


      if (invalid) {
        return
      }
      this.loadingProcess = "processing"
      const payload = {
        clientId: this.requestData.clientId,
        requestId: this.requestData.id,
        rating: this.reviewModel.questions.map(item => ({
          question: item.question,
          rating: parseInt(item.value)
        })),
        comment: this.reviewModel.comment
      }
      console.log("payload", payload)
      this.submit("review-client", payload)
    },
    // async downloadPaymentNote(requestId, ref, clientId) {
    //   const axios = require("axios")
    //   const user = auth.currentUser
    //   if (user == null) {
    //     alert("sorry cont do this right now")
    //     return
    //   }
    //
    //   const analytics = getAnalytics()
    //   logEvent(analytics, "click", {
    //     item_id: "download",
    //     page_title: this.$route.name
    //   })
    //
    //   const token = await user.getIdToken()
    //   const functionUrl = FirebaseFunctionsHelper.getFunctionsUrl("download-paymentNote")
    //   const config = {
    //     method: "get",
    //     url: functionUrl+"?requestId=" + requestId + "&clientId=" + clientId,
    //     responseType: "blob",
    //     headers: {
    //       "Authorization": "Bearer " + token
    //     }
    //   }
    //   this.$swal.showLoading()
    //   const self = this
    //   axios(config)
    //       .then(function (response) {
    //         console.log(response)
    //         const href = URL.createObjectURL(response.data)
    //
    //         // create "a" HTML element with href to file & click
    //         const link = document.createElement("a")
    //         link.href = href
    //         link.setAttribute("download", "Payment_Note_" + ref + ".pdf") //or any other extension
    //         document.body.appendChild(link)
    //         link.click()
    //         self.$swal.close()
    //         // clean up "a" element & remove ObjectURL
    //         document.body.removeChild(link)
    //         URL.revokeObjectURL(href)
    //       })
    //       .catch(function (error) {
    //         self.$swal.close()
    //         console.log(error)
    //       })
    //
    //
    // },
    tryPurchase(){
      console.log("this.$store.state.user", this.$store.state.user.data.status)
      if (this.userRole === "employee" && this.$store.state.user.data.status !== "active") {
        this.$swal.fire({
          title: "You cannot purchase this shift",
          html: "In order to purchase this shift you need to be Active",
          icon:"warning",
          customClass:{
            confirmButton: "bg-primary"
          }
          // timer: 1000,
          // timerProgressBar: true
        })
        return
      }
      this.getEmployees()
      this.assignModalBool = true
    },
    getValueOrDefault(obj, prop, defaultValue){
      return Object.prototype.hasOwnProperty.call(obj, prop) ? (obj[prop] || defaultValue) : defaultValue
    },
    assignRequest(){
      let payload

      if (this.termsAndConditions === false){
        this.termsAndConditionsDirty = true
        return
      } else {
        this.termsAndConditionsDirty = false
      }
      if (this.userRole === "system") {
        this.v$.$touch()

        if (this.v$.assignEmployeeId.$invalid) {
          console.log(this.v$.$errors)
          return
        }

        payload = {
          id: this.requestData.id,
          employeeId: this.assignEmployeeId.id,
        }
        // assign to user
        return
      } else {
        payload = {
          employeeId: this.$store.state.user.claims.user_id,
          id: this.requestData.id,
        }
      }
      // this.loadingProcess = "processing"
      console.log("request buy", payload)

      this.showCheckoutPage = true
    },
    verifyRequest(){
      this.$swal.fire({
        title: "Are you sure?",
        text: "You are about to Verify this request",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, verify!",
        confirmButtonColor: "green",
        cancelButtonColor: "#dc3545",
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          FirebaseFunctionsHelper.callFunction("request-verify",
              {
                clientId: this.requestData.clientId,
                requestId: this.requestData.id
              }
          )
              .then((result) => {
                console.log("res", result)
                if (result != null && result.hasOwnProperty("message")) {
                  this.$swal.fire({
                    icon: "error",
                    html: result.message,
                    title: "Something went wrong!",
                  })
                  return
                }
                // this.$parent.$parent.$parent.$parent.getRequest()
                this.$emit("getRequest")
                this.$swal.fire({
                  title: "Verified!",
                  html: "The request was verified.",
                  icon:"success",
                  timer: 1000,
                  timerProgressBar: true
                })

              }, this)
              .catch((error) => {
                console.error("submitUser error", error)
                this.$swal.fire({
                  icon: "error",
                  html: result.message,
                  title: "Something went wrong!",
                })
              })
        }
      })
    },
    cancelPurchasedRequest(){
      this.v$.$touch()

      if (this.v$.reason.$invalid) {
        console.log(this.v$.$errors)
        return
      }

      this.loadingProcess = "processing"

      let payload = {
        id: this.requestData.id,
        reason: this.reason,
      }

      if (this.userRole === "system"){
        payload["status"] = "verified"
      }
      console.log("cancel", payload)

      this.submit("request-cancel", payload)
    },
    markNoShow(){
      this.loadingProcess = "processing"
      let payload = {
        id: this.requestData.id,
        reason: null,
      }

      this.submit("request-noShow", payload)
    },
    cancelRequest(){
      this.v$.$touch()

      if (this.v$.reason.$invalid || this.v$.cancelActions.$invalid) {
        console.log(this.v$.$errors)
        return
      }

      this.loadingProcess = "processing"

      let payload = {
        id: this.requestData.id,
        reason: this.reason,
      }

      if (this.userRole === "system"){
        payload["status"] = this.requestData.buyerId ? this.cancelActions.key : "canceled"
      }

      console.log("cancel", payload)

      this.submit("request-cancel", payload)

    },
    submit(name, data){
      FirebaseFunctionsHelper.callFunction(name, data)
          .then((result) => {
            console.log("res", result)
            // eslint-disable-next-line no-prototype-builtins
            if (result != null && result.hasOwnProperty("message")) {
              console.log("result message", result.message)
              this.loadingProcess = "failed"
              this.errorMessage = result.message
              return
            }
            this.loadingProcess = "done"

            // if (this.userRole !== "system"){
            //   this.$parent.$parent.$parent.getRequest()
            // } else {
            //   this.$parent.$parent.$parent.$parent.getRequest()
            // }
            this.$emit("getRequest")
            this.cancelModal = false
            this.cancelPurchaseModal = false
            this.assignModalBool = false
            this.showReviewRequest = false
          })
          .catch((error) => {
            this.loadingProcess = "failed"
            this.errorMessage = error.message
            console.log("submitUser error", error)
          })

    },
    async getEmployees() {
      if (this.userRole !== "system"){
        return
      }
      await this.$store.dispatch("fetchEmployees", {type: this.requestData.type, status: "active" , limit: 150}).then((data) => {
        console.log("fetchEmployees", data)
        this.employees = data.data
      })
    },
  }
}
</script>

<style scoped>

</style>